import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _values from "lodash/values";
import _isNil from "lodash/isNil";
import _get from "lodash/get";
import "core-js/modules/es6.array.map.js";
import React, { useContext } from 'react';
import { ImpressionContext } from '@nerdwallet/analytics/react/impression';
import { colors } from '@nerdwallet/base-styles/variables';
import { getLegacyId, getThisYearBestOfAwards } from '@nerdwallet/marketplace/selectors/common';
import MarketplaceApplyNow, { APPLY_NOW_LINK_TYPES, LINK_TYPES, APPLY_NOW_FINISH_TYPES } from '@nerdwallet/react-marketplace-apply-now';
import { PREHEADER_TYPE, SENTIMENT_TYPE, TRK_PRODUCT_LOCATION } from '../lib/constants';
import { buildTrkSectionCategory, getMonetizable } from '../lib/utils';
import KetoProductCardHeader from './keto-header';
import KetoImageAndRating from './keto-image-rating-wrapper';
import KetoAccordion from './accordion-content';
import KetoDrivers from './keto-drivers';
import Preheader from '../preheader';
import mapMarketplaceEntityToProps, { DRIVER_GROUPS } from '../mappings';
import styles from "./keto-product-card.module.css";
import ProductCardImageWrapper from '../product-card-image-wrapper';
import { BaseKetoProductCard } from './base-keto-product-card';
export var KetoProductCard = function KetoProductCard(props) {
  var _analytics$productImp, _analytics$productImp2, _analytics$productImp3, _analytics$productImp4, _analytics$productImp5, _analytics$productImp6, _analytics$productImp7, _analytics$productImp8, _analytics$productImp9;
  var impressionContext = useContext(ImpressionContext);
  if (!props.marketplaceEntity) {
    return null;
  }
  var mappedProps = mapMarketplaceEntityToProps(_objectSpread(_objectSpread({}, props), {}, {
    isKetoCard: true
  }));
  var _compareCards = mappedProps._compareCards,
    _hasCcCompareButton = mappedProps._hasCcCompareButton,
    _handleCcCompareClick = mappedProps._handleCcCompareClick,
    bottomLine = mappedProps.bottomLine,
    checkboxLabel = mappedProps.checkboxLabel,
    className = mappedProps.className,
    cons = mappedProps.cons,
    ctaHref = mappedProps.ctaHref,
    ctaShowIcon = mappedProps.ctaShowIcon,
    ctaSubtext = mappedProps.ctaSubtext,
    ctaText = mappedProps.ctaText,
    drivers = mappedProps.drivers,
    enableAnalytics = mappedProps.enableAnalytics,
    forceMobile = mappedProps.forceMobile,
    heading = mappedProps.heading,
    imageData = mappedProps.imageData,
    isSelectedToCompare = mappedProps.isSelectedToCompare,
    lazyLoadEnabled = mappedProps.lazyLoadEnabled,
    marketplaceEntity = mappedProps.marketplaceEntity,
    marketplaceEntitySlug = mappedProps.marketplaceEntitySlug,
    omitCta = mappedProps.omitCta,
    omitRating = mappedProps.omitRating,
    omitRatingTextHref = mappedProps.omitRatingTextHref,
    ourTakeHighlight = mappedProps.ourTakeHighlight,
    preheaderText = mappedProps.preheaderText,
    preheaderUrl = mappedProps.preheaderUrl,
    productDetails = mappedProps.productDetails,
    productType = mappedProps.productType,
    pros = mappedProps.pros,
    reviewLinkHref = mappedProps.reviewLinkHref,
    secondaryCtaHref = mappedProps.secondaryCtaHref,
    secondaryCtaText = mappedProps.secondaryCtaText,
    shouldDisplayPlaceHolder = mappedProps.shouldDisplayPlaceHolder,
    shouldLogImpression = mappedProps.shouldLogImpression,
    showBestOfAwards = mappedProps.showBestOfAwards,
    showNotYetRated = mappedProps.showNotYetRated,
    starRating = mappedProps.starRating,
    trkPageType = mappedProps.trkPageType,
    trkProductPosition = mappedProps.trkProductPosition,
    trkSectionCategory = mappedProps.trkSectionCategory,
    wrapDrivers = mappedProps.wrapDrivers;
  var _mappedProps$analytic = mappedProps.analytics,
    analytics = _mappedProps$analytic === void 0 ? {} : _mappedProps$analytic,
    _mappedProps$displayP = mappedProps.displayPage,
    displayPage = _mappedProps$displayP === void 0 ? '' : _mappedProps$displayP,
    _mappedProps$hasPrehe = mappedProps.hasPreheader,
    hasPreheader = _mappedProps$hasPrehe === void 0 ? false : _mappedProps$hasPrehe,
    _mappedProps$identity = mappedProps.identity,
    identity = _mappedProps$identity === void 0 ? {} : _mappedProps$identity,
    _mappedProps$initAcco = mappedProps.initAccordionItemExpanded,
    initAccordionItemExpanded = _mappedProps$initAcco === void 0 ? false : _mappedProps$initAcco,
    _mappedProps$preheade = mappedProps.preheaderType,
    preheaderType = _mappedProps$preheade === void 0 ? PREHEADER_TYPE.PLAIN_TEXT : _mappedProps$preheade,
    _mappedProps$preheade2 = mappedProps.preheaderHoverText,
    preheaderHoverText = _mappedProps$preheade2 === void 0 ? '' : _mappedProps$preheade2,
    _mappedProps$preheade3 = mappedProps.preheaderSentiment,
    preheaderSentiment = _mappedProps$preheade3 === void 0 ? SENTIMENT_TYPE.NEUTRAL : _mappedProps$preheade3,
    _mappedProps$showMatc = mappedProps.showMatchScoreCTA,
    showMatchScoreCTA = _mappedProps$showMatc === void 0 ? false : _mappedProps$showMatc,
    _mappedProps$taxonomy = mappedProps.taxonomy,
    taxonomy = _mappedProps$taxonomy === void 0 ? _get(global.window, 'nwPageTaxonomy') : _mappedProps$taxonomy;
  var productCardImage = /*#__PURE__*/React.createElement(ProductCardImageWrapper, {
    imageData: imageData,
    backgroundColor: colors.transparent,
    imageClassName: styles.productImage,
    className: styles.productImageWrapper,
    objectFit: "contain",
    lazyLoadEnabled: lazyLoadEnabled,
    isKetoCard: true,
    shouldDisplayPlaceHolder: shouldDisplayPlaceHolder
  });
  var legacyId = getLegacyId(marketplaceEntity);
  var mpcTrkSectionCategory = buildTrkSectionCategory(trkSectionCategory, TRK_PRODUCT_LOCATION);

  // The rates & fees link is populated in CC mapping into secondary Ctas
  var secondaryCtas = secondaryCtaText && secondaryCtaHref && /*#__PURE__*/React.createElement(MarketplaceApplyNow, {
    className: styles.secondaryCta,
    elementName: analytics === null || analytics === void 0 ? void 0 : (_analytics$productImp = analytics.productImpressionProps) === null || _analytics$productImp === void 0 ? void 0 : (_analytics$productImp2 = _analytics$productImp.payload) === null || _analytics$productImp2 === void 0 ? void 0 : _analytics$productImp2.element_name,
    finishType: APPLY_NOW_FINISH_TYPES.EXTERNAL_CONTENT,
    impressionId: impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId,
    id: APPLY_NOW_LINK_TYPES.ratesAndFeesText,
    link: secondaryCtaHref,
    linkType: APPLY_NOW_LINK_TYPES.ratesAndFeesText,
    monetizable: getMonetizable(marketplaceEntity),
    marketplaceEntity: marketplaceEntity,
    sectionName: (analytics === null || analytics === void 0 ? void 0 : (_analytics$productImp3 = analytics.productImpressionProps) === null || _analytics$productImp3 === void 0 ? void 0 : (_analytics$productImp4 = _analytics$productImp3.payload) === null || _analytics$productImp4 === void 0 ? void 0 : _analytics$productImp4.section_name) || "keto_product_card",
    sectionPosition: analytics === null || analytics === void 0 ? void 0 : (_analytics$productImp5 = analytics.productImpressionProps) === null || _analytics$productImp5 === void 0 ? void 0 : (_analytics$productImp6 = _analytics$productImp5.payload) === null || _analytics$productImp6 === void 0 ? void 0 : _analytics$productImp6.section_position,
    type: LINK_TYPES.LINK,
    shouldLogImpression: shouldLogImpression
  }, secondaryCtaText);

  // get all the added cardIds from the compare bar
  var cardIDsToCompare = _get(_compareCards, 'cardIDsToCompare') || [];

  // if the boolean isSelectedToCompare is defined (true/false) we will use the value,
  // if not, we will cardIDsToCompare and check if the
  // card id already added in the cardIDsToCompare;
  // then display the checkbox checked=true
  var isInCompare = !_isNil(isSelectedToCompare) ? isSelectedToCompare : cardIDsToCompare.indexOf(legacyId) > -1;
  var productCardPreheader = hasPreheader ? /*#__PURE__*/React.createElement(Preheader, {
    className: styles.preheader,
    trkTaxonomy: taxonomy,
    text: preheaderText,
    title: preheaderHoverText,
    trkPageType: trkPageType,
    sentiment: preheaderSentiment,
    type: preheaderType,
    url: preheaderUrl,
    isKetoCard: true
  }) : null;
  var isPreheaderBadge = preheaderType === PREHEADER_TYPE.BADGE;
  if (showBestOfAwards) {
    var thisYearAwards = getThisYearBestOfAwards(marketplaceEntity);
    if (thisYearAwards !== null && thisYearAwards !== void 0 && thisYearAwards.length) {
      var thisYearAwardsText = thisYearAwards.map(function (value) {
        return value.category;
      }).join(', ');
      mappedProps.hasPreheader = true;
      mappedProps.preheaderHoverText = thisYearAwardsText;
      mappedProps.preheaderText = thisYearAwardsText;
      mappedProps.preheaderType = PREHEADER_TYPE.BADGE;
    }
  }
  return /*#__PURE__*/React.createElement(BaseKetoProductCard, {
    accordionNode: /*#__PURE__*/React.createElement(KetoAccordion, {
      analytics: analytics === null || analytics === void 0 ? void 0 : analytics.accordionProps,
      bottomLine: bottomLine,
      cons: cons,
      enableAnalytics: enableAnalytics,
      initAccordionItemExpanded: initAccordionItemExpanded,
      productDetails: productDetails,
      pros: pros
    }),
    className: className,
    driversNode: !!drivers ? /*#__PURE__*/React.createElement(KetoDrivers, {
      analytics: analytics === null || analytics === void 0 ? void 0 : analytics.driverProps,
      className: styles.drivers,
      enableAnalytics: enableAnalytics,
      drivers: drivers,
      wrapDrivers: wrapDrivers
    }) : null,
    forceMobile: forceMobile,
    headerNode: /*#__PURE__*/React.createElement(KetoProductCardHeader, {
      className: hasPreheader ? styles.header : styles.headerWithNoPreHeader,
      heading: heading,
      marketplaceEntity: marketplaceEntity,
      marketplaceEntitySlug: marketplaceEntitySlug,
      productType: productType,
      reviewLinkHref: reviewLinkHref,
      shouldLogImpression: shouldLogImpression,
      taxonomy: taxonomy,
      trkPageType: trkPageType,
      trkProductPosition: trkProductPosition,
      trkSectionCategory: mpcTrkSectionCategory
      // compare button specific props
      ,
      _hasCcCompareButton: _hasCcCompareButton,
      _handleCcCompareClick: _handleCcCompareClick,
      checkboxLabel: checkboxLabel,
      isSelectedToCompare: isSelectedToCompare
      // BNK specific props
      ,
      displayPage: displayPage,
      hasPreheader: hasPreheader,
      productCardPreheader: productCardPreheader,
      isPreheaderBadge: isPreheaderBadge
      // bedrock
      ,
      enableAnalytics: (analytics === null || analytics === void 0 ? void 0 : analytics.enabled) || enableAnalytics
    }),
    imageAndRatingNode: /*#__PURE__*/React.createElement(KetoImageAndRating, {
      analytics: analytics === null || analytics === void 0 ? void 0 : analytics.imageAndRatingProps,
      productCardImage: productCardImage,
      ctaHref: ctaHref,
      ctaSubtext: ctaSubtext,
      enableAnalytics: enableAnalytics,
      imageData: imageData,
      id: "".concat(TRK_PRODUCT_LOCATION, "__product-button--under-image--").concat(trkProductPosition),
      identity: identity,
      marketplaceEntity: marketplaceEntity,
      marketplaceEntitySlug: marketplaceEntitySlug,
      productType: productType,
      secondaryCtas: secondaryCtas,
      ctaShowIcon: ctaShowIcon,
      ctaText: ctaText,
      omitRating: omitRating,
      omitRatingTextHref: omitRatingTextHref,
      starRating: starRating,
      reviewLinkHref: reviewLinkHref,
      omitCta: omitCta,
      shouldLogImpression: shouldLogImpression,
      taxonomy: taxonomy,
      trkPageType: trkPageType,
      trkProductPosition: trkProductPosition,
      trkSectionCategory: mpcTrkSectionCategory
      // BNK specific props
      ,
      displayPage: displayPage,
      showNotYetRated: showNotYetRated
      // CC specific props
      ,
      showMatchScoreCTA: showMatchScoreCTA
    }),
    isInCompare: isInCompare,
    isPreheaderBadge: isPreheaderBadge,
    ourTakeHighlight: ourTakeHighlight,
    sectionName: (_analytics$productImp7 = analytics === null || analytics === void 0 ? void 0 : (_analytics$productImp8 = analytics.productImpressionProps) === null || _analytics$productImp8 === void 0 ? void 0 : (_analytics$productImp9 = _analytics$productImp8.payload) === null || _analytics$productImp9 === void 0 ? void 0 : _analytics$productImp9.section_name) !== null && _analytics$productImp7 !== void 0 ? _analytics$productImp7 : 'keto_product_card'
  });
};
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');
  KetoProductCard.propTypes = {
    // used in mapping function
    driverGroup: PropTypes.oneOf(_values(DRIVER_GROUPS)),
    // eslint-disable-line react/no-unused-prop-types
    marketplaceEntity: PropTypes.object.isRequired,
    // eslint-disable-line react/forbid-prop-types
    marketplaceEntitiesForCdApyTerms: PropTypes.shape({
      // eslint-disable-next-line react/forbid-prop-types
      oneYear: PropTypes.object,
      // eslint-disable-next-line react/forbid-prop-types
      threeYear: PropTypes.object,
      // eslint-disable-next-line react/forbid-prop-types
      fiveYear: PropTypes.object
    }),
    // it is used but no sure why this is an error -\_(=))_/-
    wrapDrivers: PropTypes.bool,
    // eslint-disable-line react/no-unused-prop-types
    // used in mapping
    hidePrequalCta: PropTypes.bool,
    // eslint-disable-line react/no-unused-prop-types
    // Keto Card specific props
    // it is used but no sure why this is an error -\_(=))_/-
    checkboxLabel: PropTypes.string,
    // eslint-disable-line react/no-unused-prop-types
    analytics: PropTypes.shape({
      productImpressionProps: PropTypes.shape({
        payload: PropTypes.shape({
          element_position: PropTypes.number,
          section_name: PropTypes.string,
          section_position: PropTypes.number
        })
      }),
      imageAndRatingProps: PropTypes.shape({
        entityName: PropTypes.string
      }),
      driverProps: PropTypes.shape({
        entityName: PropTypes.string
      }),
      accordionProps: PropTypes.shape({
        ourTakeProps: PropTypes.shape({
          entityName: PropTypes.string,
          sectionName: PropTypes.string,
          sectionPosition: PropTypes.number
        }),
        loaCtaProps: PropTypes.shape({
          sectionName: PropTypes.string,
          sectionPosition: PropTypes.number,
          driverPageName: PropTypes.string,
          driverFlowName: PropTypes.string,
          driverPageViewId: PropTypes.string,
          contentId: PropTypes.string,
          deployableName: PropTypes.string,
          deployableVersion: PropTypes.string
        }),
        productDetailsProps: PropTypes.shape({
          entityName: PropTypes.string,
          sectionName: PropTypes.string,
          sectionPosition: PropTypes.number
        })
      }),
      prequalCTATrk: PropTypes.string,
      /** @deprecated Used by accordion */

      payload: PropTypes.shape({
        elementName: PropTypes.string
      })
    }),
    ourTakeHighlightEntityName: PropTypes.string,
    // eslint-disable-line react/no-unused-prop-types
    // the following props are used in the mapping function and not the component directly.
    forceMobile: PropTypes.bool,
    // eslint-disable-line react/no-unused-prop-types
    lazyLoadEnabled: PropTypes.bool,
    // eslint-disable-line react/no-unused-prop-types
    approvalOddsEnabled: PropTypes.bool,
    // eslint-disable-line react/no-unused-prop-types
    shouldDisplayPlaceHolder: PropTypes.bool // eslint-disable-line react/no-unused-prop-types
  };
}

KetoProductCard.defaultProps = {
  approvalOddsEnabled: false,
  driverGroup: DRIVER_GROUPS.DEFAULT_DRIVER_GROUP,
  marketplaceEntitiesForCdApyTerms: {},
  wrapDrivers: false,
  // CC specific props
  hidePrequalCta: false,
  // analytics
  analytics: {},
  lazyLoadEnabled: false
};
KetoProductCard.displayName = 'KetoProductCard';